import {ProjectSystemType} from "../../../../../../core/model2/project/types"

const expenses = {
    "id": "eiRwDy",
    "name": "Expense Tracking",
    "img": "/app/static/templates/business/expense-tracking.jpg",
    "description": "Use this template as a pre-configured expense tracking sheet.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Administration',
    demoFolderColor: 8
};

const eventManagement = {
    "id": "hkRtdg",
    "name": "Office event mgmt.",
    "img": "/app/static/templates/business/office-events.jpg",
    "description": "Calendar and task list to organize and manage internal events.",
    copyToLocalTemplate: false,
    systemType: ProjectSystemType.FOLDER,
    setupDemoProject: 'Administration',
    demoFolderColor: 8
};

// const travelTracker = {
//     "id": "IQt4OZ",
//     "name": "Team Travel Tracker",
//     // "icon": "i5-project",
//     "img": "/app/static/templates/business/travel.jpg",
//     "description": "Some long description here to show purpose of this template",
//     systemType: ProjectSystemType.FOLDER,
// };

const inventory = {
    "id": "EN7mYr",
    "name": "Office Inventory",
    "img": "/app/static/templates/business/inventory.jpg",
    "description": "Use this template to track and manage stock of office supplies.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Administration',
    demoFolderColor: 8
};

const vendors = {
    "id": "vevaaD",
    "name": "Vendor Management",
    "img": "/app/static/templates/hr/contractors.jpg",
    "description": "Template for vendor relationship management and tracking.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Administration',
    demoFolderColor: 8
};

export default {
    id: 'business',
    name: "Business & Administration",
    items: [
        expenses,
        eventManagement,
        // travelTracker,
        inventory,
        vendors,
    ]
};